import React from 'react';
import {
  Box, makeStyles, useMediaQuery, useTheme,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import ContentWrap from '../atoms/ContentWrap';
import BlackOctoberHomeDetail from '../../static/images/black-october-home-detail.png';
import BlackOctoberTrocarContadorBg from '../../static/images/black-october-trocar-contador-bg.png';

const pageBackground = {
  home: {
    background: 'linear-gradient(0deg, #00538B 0%, rgba(0, 147, 245, 1) 40.23%)',
    height: '272px',

  },
  'home-black-october': {
    background: 'linear-gradient(180deg, #00243F 0%, #004C79 100%)',
    height: '359px',
  },
  'abrir-empresa': {
    background: 'linear-gradient(0deg, #134CB7 0%, #2370FF)', // Posteriormente ageitar a o degradê
    // backgroundImage: 'url(/webp/background-pattern-blue.svg)',
  },
  'abrir-empresa-black-october': {
    background: 'linear-gradient(180deg, #00243F 0%, #092D67 48%, #1946A0 100%)',
    boxSizing: 'border-box',
    height: '476px',
  },
  'trocar-contador': {
    background: 'linear-gradient(180deg,#0CB49D 0%,#0A7768 100%)',
  },
  'trocar-contador-black-october': {
    backgroundColor: '#0A2A24',
    backgroundImage: `url(${BlackOctoberTrocarContadorBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    boxSizing: 'border-box',
    height: '454px',
  },
  solucoes: {
    background: 'linear-gradient(0deg, #0065AA, #018DEA )',
    height: '243px',
  },
  'quanto-custa': {
    background: 'linear-gradient(180deg,#1da1f2 0%,#0077c8 100%)',
  },
  'quanto-custa-black-october': {
    background: 'linear-gradient(180deg, #00243F 0%, #004C79 100%)',
    boxSizing: 'border-box',
    height: '505px',
  },
  'purple-friday': {
    background: '#1A1738',
    backgroundImage: 'url(/images/purple-friday.svg)',
  },
  'calculadora-salario': {
    background: 'linear-gradient(0deg, #00538B 0%, #0093F5 100%)',
  },
  'calculadora-impostos': {
    background: 'linear-gradient(0deg, #00538B 0%, #0093F5 100%)',
  },
};

const pageMobileBackground = {
  home: {
    background: 'linear-gradient(0deg, #00538B 0%, rgba(0, 147, 245, 1) 40%)',
    marginTop: '0px',
    height: '560px',
    minHeight: '560px',
  },
  'home-black-october': {
    background: 'linear-gradient(180deg, #00243F 0%, #004C79 100%)',
    marginTop: '0px',
    height: '560px',
    minHeight: '560px',
  },
  'abrir-empresa': {
    background: 'linear-gradient(0deg, #134CB7 0%, #2370FF)',
  },
  'abrir-empresa-black-october': {
    background: 'linear-gradient(180deg, #00243F 0%, #092D67 48%, #1946A0 100%)',
    boxSizing: 'border-box',
    height: '491px',
  },
  'trocar-contador': {
    background: 'linear-gradient(180deg,#0CB49D 0%,#0A7768 100%)',
  },
  'trocar-contador-black-october': {
    backgroundColor: '#0A2A24',
    backgroundImage: `url(${BlackOctoberTrocarContadorBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    boxSizing: 'border-box',
    height: '500px',
  },
  solucoes: {
    background: 'linear-gradient(0deg, #0065AA, #018DEA )',
    height: '100px',
  },
  'quanto-custa': {
    background: 'linear-gradient(180deg,#1da1f2 0%,#0077c8 100%)',
  },
  'quanto-custa-black-october': {
    background: 'linear-gradient(180deg, #00243F 0%, #004C79 100%)',
    boxSizing: 'border-box',
    height: '447px',
  },
  'purple-friday': {
    background: '#1A1738',
    backgroundImage: 'url(/images/purple-friday.svg)',
  },
  'calculadora-salario': {
    background: 'linear-gradient(0deg, #00538B 0%, #0093F5 100%)',
  },
  'calculadora-impostos': {
    background: 'linear-gradient(0deg, #00538B 0%, #0093F5 100%)',
  },
};

const HeroBackground = ({ page, children }) => {
  const theme = useTheme();
  const isHomePage = page === 'home' || page === 'home-black-october';
  const useStyles = makeStyles(() => ({
    blackOctoberDetail: {
      position: 'absolute',
      inset: 0,
      backgroundImage: `url(${BlackOctoberHomeDetail})`,
      backgroundPosition: 'center 15%',
      backgroundRepeat: 'repeat',
      backgroundSize: '980px auto',
      opacity: 0.08,
      pointerEvents: 'none',
    },
    root: {
      position: 'absolute',
      zIndex: (isHomePage || page === 'solucoes') ? 0 : -1,
      right: 0,
      left: 0,
      padding: page === 'quanto-custa-black-october' ? '25px 0 90px' : (page === 'trocar-contador-black-october' ? '38px 0 0' : (page === 'abrir-empresa-black-october' ? '32px 0 0' : '90px 0')),
      backgroundRepeat: 'no-repeat',
      backgroundPosition: isHomePage ? 'left' : 'center',
      ...pageBackground[page],
      ...(page === 'home-black-october' && {
        '@media screen and (min-width: 1291px)': { height: '298px' },
      }),

      '& .text': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: '10px',
        justifyContent: 'center',

        '& .MuiTypography-root': {
          color: theme.palette.secondary.contrastText,
        },
      },

      '& .span': {
        fontSize: '16px',
        lineHeight: '22px',
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
      },

      '& .title, & .title strong': {
        lineHeight: '54px',
      },

      '@media screen and (max-width: 960px)': {
        paddingTop: (page === 'trocar-contador-black-october' || page === 'abrir-empresa-black-october') ? '0px' : '75px',
        minHeight: '290px',
        ...pageMobileBackground[page],
        // Nas calculadoras o hero entra no fluxo no mobile (em vez de absolute),
        // pra ocupar a altura real do texto e nao deixar o form cobrir a descricao.
        ...(page.includes('calculadora') && {
          position: 'relative',
          zIndex: 0,
          minHeight: 'unset',
          paddingBottom: '40px',
          marginTop: '12px',
        }),

        '& .title, & .title strong': { lineHeight: '32px' },
        '& .span': {
          fontSize: '14px',
          letterSpacing: '0.04em',
        },
        '& .MuiTypography-h3': { fontSize: '24px' },
      },
    },
    // box: { height: '332px' },
  }));
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box className={classes.root} >
      {(page === 'home-black-october' || page === 'quanto-custa-black-october') && <Box className={classes.blackOctoberDetail} aria-hidden="true" />}
      <ContentWrap overfloHidden={!isHomePage} className={classes.box}>{children}</ContentWrap>
    </Box>
  );
};

HeroBackground.defaultProps = {
  page: 'home',
  children: <></>,
};

HeroBackground.propTypes = {
  page: PropTypes.string,
  children: PropTypes.element,
};

export default HeroBackground;
